// context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const isLoggedIn = !!token;

  const authFetch = (url, options = {}) => {
    const headers = { ...(options.headers || {}) };
    if (token) headers.Authorization = `Bearer ${token}`;
    return fetch(url, { ...options, headers });
  };

  const fetchUserData = async (tkn = token) => {
    if (!tkn) { setIsLoading(false); return; }
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/user`, {
        headers: { Authorization: `Bearer ${tkn}` },
      });
      if (res.ok) {
        const data = await res.json();
        setUser(data);
      } else if (res.status === 401) {
        // token nieważny
        logout(false);
      }
    } catch (e) {
      console.error("Błąd pobierania /api/auth/user:", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const t = localStorage.getItem("token");
    const u = localStorage.getItem("user");
    if (t) setToken(t);
    if (u) setUser(JSON.parse(u));
    fetchUserData(t);
  }, []);

  const login = (jwt, userDto) => {
    setToken(jwt);
    setUser(userDto);
    localStorage.setItem("token", jwt);
    localStorage.setItem("user", JSON.stringify(userDto));
    fetchUserData(jwt);
  };

  const logout = (redirect = true) => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    if (redirect) window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, token, isLoggedIn, isLoading, login, logout, authFetch }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
